<template>
  <div class="websites-page">
    <div class="loading-spinner-outer" v-if="sending">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Sending, please wait
        </div>
      </div>
    </div>
    <div class="box _gradient-bar">
      <div class="powered-by-title-bar">
        <div class="title">
          <h1>
            Websites
          </h1>
        </div>
        <div class="logo">
          <img src="/images/powered-by-logo-the-consultancy.png">
        </div>
      </div>
      <div class="box-1">
        <h1>
          Stand out online with a professional website.
        </h1>
        <p>
          Trusted by over 1000 fenestration businesses!
        </p>
        <a class="btn-primary" href="#themes">
          Browse Themes
        </a>
      </div>
      <div class="overlapping-image">
        <img src="/images/website-page-overlay-image.png">
      </div>
      <div class="box-2">
        <div class="content _primary align-center">
          <h1>Complete Website Solution</h1>
          <p>
            Backed by expert 24/7 support, low prices and huge selection.
          </p>
          <div class="cols">
            <div class="col">
              <div class="icon">
                <i class="fal fa-paint-bucket"></i>
              </div>
              Beautiful themes that are responsive and customizable
            </div>
            <div class="col">
              <div class="icon">
                <i class="fal fa-paint-tags"></i>
              </div>
              Prices from just £999 (one off payment)
            </div>
            <div class="col">
              <div class="icon">
                <i class="fal fa-user-hardhat"></i>
              </div>
              Designed specifically for EPWIN customers
            </div>
          </div>
        </div>
      </div>
      <div class="box-3">
        <div class="col-info">
          <div>
            <h1>
              No headache, No stress!
              Premium glazing web designs
              at affordable prices
            </h1>
            <p>
              During 20 years in the industry we have
              helped over 500 start up businesses
              appear online. We offer a quick and easy service
              tailor made for your business.
            </p>
          </div>
        </div>
        <div class="col-image">
          <img src="/images/website-landing-page-image-box-3.png">
        </div>
      </div>
      <div class="website-themes-box" id="themes">
        <h1>
          Award-winning websites
        </h1>
        <p>
          Backed by expert 24/7 support, Low prices and huge selection
        </p>
        <div class="website-themes">
          <div class="website-theme" v-for="theme in [11,10,9,8,7,6,5,4,3,2,1]">
            <div class="content">
              <div class="image">
                <img :src="`/images/website-theme-thumb-${theme}.png`">
              </div>
              <div class="title" v-if="theme >= 9">
                Website Theme {{ theme }} <span class="txt-positive">** NEW **</span>
              </div>
              <div class="title" v-else>
                Website Theme {{ theme }}
              </div>
              <div class="price" v-if="theme >= 9">
                From just £1999
              </div>
              <div class="price" v-else>
                From just £999
              </div>
              <div class="buttons">
                <a class="btn-primary" :href="`/web-support/websites/demo/${theme}`" target="_blank">
                  View Demo
                </a>
                <a class="btn-primary"
                   @click.prevent="enquiry_box_open = true, enquiry_message = `I am interested in website theme ${theme}, could you send me some information on how to purchase, thank you.`">
                  Make Enquiry
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="how-it-works-box">
        <h1>
          How it works
        </h1>
        <div class="panels">
          <div class="panel">
            <div class="content">
              <div class="icon">
                <i class="fal fa-website"></i>
              </div>
              <strong>
                Choose a theme
              </strong>
              <p>
                Select a a theme and you can have your own professional website online and fully
                personalised to your company in just a matter of days.
              </p>
            </div>
          </div>
          <div class="arrow">
            <i class="fa fa-arrow-right"></i>
          </div>
          <div class="panel">
            <div class="content">
              <div class="icon">
                <i class="fal fa-basket"></i>
              </div>
              <strong>
                Buy online
              </strong>
              <p>
                Pay securely online via our online web store, all websites are available in a one off
                payment of from just £999. Terms and conditions apply and doesnt include hosting.
              </p>
            </div>
          </div>
          <div class="arrow">
            <i class="fa fa-arrow-right"></i>
          </div>
          <div class="panel">
            <div class="content">
              <div class="icon">
                <i class="fal fa-basket"></i>
              </div>
              <strong>
                Choose your products
              </strong>
              <p>
                Select which products you want to offer from the Epwin range including: Stellar, Profile
                22, Swish, PatioMaster, Spectus and Safeware.
              </p>
            </div>
          </div>
          <div class="arrow">
            <i class="fa fa-arrow-right"></i>
          </div>
          <div class="panel">
            <div class="content">
              <div class="icon">
                <i class="fal fa-user-card"></i>
              </div>
              <strong>
                Supply your company info
              </strong>
              <p>
                Supply us your company logo, brand colours, contact details and about us information and
                then you can be live within 1 week.
              </p>
            </div>
          </div>
        </div>
        <div class="quote">
          <h1>
            “I went from selling to my town, to selling
            nationwide in one week. It’s a whole new business now.”
          </h1>
          <p>
            Andrew Johnson, MD Leighton Buzzard Home Improvements
          </p>
        </div>
      </div>
      <div class="website-support-box">
        <div class="cols">
          <div class="col-info">
            <h1>Website Support</h1>
            <p>
              Dont worry if you are not tech savy, our team will take care of everything. We can also work alongside
              your seo team to help drive traffic to your website.
            </p>
            <p>
              Call us now for more information on 01429 239 689
            </p>
            <p>
              <a class="btn-primary-outline"
                 @click="enquiry_box_open = true, enquiry_message = 'I am interested in a website theme, could you send me some information on how to purchase, thank you.'">
                Make an enquiry
              </a>
            </p>
          </div>
          <div class="col-image">
            <img src="/images/website-support-box-image.png">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="enquiry_box_open = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-header">
          <h1 class="modal-title">Thank you for your interest</h1>
        </div>
        <div class="modal-content">
          <div class="form-group">
            Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent
            a notification when you receive a reply.
          </div>
          <div class="mb-6">
            If you would like to provide some more information you can edit the message below.
          </div>
          <strong class="block pl-2 pb-1">Your Message</strong>
          <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
        </div>
        <div class="modal-footer align-right">
          <a class="btn-primary" @click="sendEnquiry()">
            Send
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'system_types',
  ],
  data() {
    return {
      'enquiry_box_open': false,
      'enquiry_message': 'I am interested in a website theme, could you send me some information on how to purchase, thank you.',
      sending: false,
    }
  },
  methods: {
    sendEnquiry() {
      this.enquiry_box_open = false;
      this.sending = true;
      axios.post('/enquiry/send', {
        'enquiry_type_id': 1,
        'message': this.enquiry_message,
      }).then((response) => {

        gtag('event', 'enquiry_made', {
          'event_category': 'enquiries',
          'event_label': 'Website theme enquiry',
          'value': 'Website theme enquiry',
        });

        this.sending = false;
        Swal.fire({
          title: 'Enquiry Sent',
          icon: 'success',
          text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
        });
      });
    },
  },
};
</script>
